module.exports = __webpack_public_path__ + "static/accounts_aws_china_secrets-12a949fd609017c025711f3cdd688f07.png";